import { render } from "./UploadDetail.vue?vue&type=template&id=77c6a6e6"
import script from "./UploadDetail.vue?vue&type=script&lang=js"
export * from "./UploadDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__